import { FC } from 'react';
import CommonWrapper from '../components/ui_components/CommonComponentsStructureCss';
import styled from 'styled-components';
import colors from '../styles/colors';
import buttonsForumObj from '../components/stats_components/buttonsForumObj';

interface ForumButton {
    title: string;
    url: string;
}

const Container = styled.div`
    width: 50%;
    margin: 0 auto;
    padding: 30px;

    & .info-stats-forum-desktop {
        text-align: center;
        margin: 0;
        padding: 0;
        font-size: 18px;
        font-weight: 600;
        color: white;
        letter-spacing: 3px;
    }
`;

const BoxAllButtons = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
    padding: 20px 0;
`;

const SpaceButtonStatForum = styled.div`
    width: 48%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & button.button-stats-forum-desktop {
        min-width: 120px;
        max-width: 300px;
        width: 80%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: black;
        border: 2px solid white;
        border-radius: 5px;
        color: white;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 3px;
        box-shadow: 0 0 10px rgba(0,0,0,0.5);

        &:hover {
            background-color: ${colors.bgColorBlack2};
            color: white;
            border: 2px solid white;
            transform: scale(1.05);
            transition: all 0.3s ease;
        }
    }
`;

const StatsForumDesktop: FC = () => {
    const buttons: ForumButton[] = buttonsForumObj;

    return (
        <CommonWrapper className="wrapper-stats-forum-desktop">
            <Container className="container-stats-forum-desktop">
                <p className="info-stats-forum-desktop">
                    I pulsanti rimandano a specifiche pagine di statistiche presenti sul forum.
                </p>
                <BoxAllButtons className="box-all-buttons-stats-forum-desktop">
                    {buttons.map((button, index) => (
                        <SpaceButtonStatForum
                            key={index}
                            className="space-button-stats-forum-desktop"
                            onClick={() => window.open(button.url, '_blank')}
                        >
                            <button className="button-stats-forum-desktop" onClick={() => window.open(button.url, '_blank')}>
                                {button.title}
                            </button>
                        </SpaceButtonStatForum>
                    ))}
                </BoxAllButtons>
            </Container>
        </CommonWrapper>
    );
};

export default StatsForumDesktop;
